<script>
    import { onMount } from "svelte";

    import { user } from "../../../stores";

    import { getAmountInCurrency } from "../../../Utils/utilFunctions.svelte";

    export let monthlyPayments = [];

    $: isUserAdmin = $user.role == 100;

    $: showEstimatedRevenue = isUserAdmin && isAppDomain;

    onMount(() => {
        monthlyPayments = monthlyPayments.length
            ? [...monthlyPayments.reverse()]
            : [];

        _checkIfAppDomain();
    });

    let dateFormatter = new Intl.DateTimeFormat("en-US", {
        month: "long",
        year: "numeric",
    });

    let isAppDomain = false;

    // HELPER FUNCTIONS
    const _getMonthName = (date) => {
        return dateFormatter.format(new Date(date));
    };

    const _checkIfAppDomain = () => {
        const hostName = window.location.hostname;
        const subDomain = hostName.split(".")[0];

        isAppDomain = subDomain === "app";
    };
</script>

<div class="flex-1 flex flex-col p-6">
    {#if monthlyPayments.length == 0}
        <div class="flex-1 items-center text-center">Nothing to display</div>
    {:else}
        {#each monthlyPayments as item, i}
            <div class="mb-2 pb-1 flex-1 border-b border-gray-200">
                <div class="flex flex-row justify-start items-center">
                    {_getMonthName(item.month)}
                </div>
                <div class="flex">
                    <div class="flex-1">
                        Patient payments: <b
                            >{getAmountInCurrency(item.paidByCustomer)}</b
                        >
                    </div>
                    <div class="flex-1">
                        Health fund payments: <b
                            >{getAmountInCurrency(item.paidByHealthFund)}</b
                        >
                    </div>
                    <div class="flex-1">
                        Total payments: <b
                            >{getAmountInCurrency(
                                item.paidByCustomer + item.paidByHealthFund,
                            )}</b
                        >
                    </div>
                    {#if showEstimatedRevenue}
                        <div class="flex-1">
                            Estimated Revenue: <b
                                >{getAmountInCurrency(
                                    (item.paidByCustomer +
                                        item.paidByHealthFund) *
                                        0.02,
                                )}</b
                            >
                        </div>
                    {/if}
                </div>
            </div>
        {/each}
    {/if}
</div>

<style>
</style>
